import { PulseBaseProvider } from '../../base-classes';
import { getLength } from '../../utilities/unitConversion';

const _precipitationMonthlyUri = '/data/Precip/v1/MonthlyByLatLon';
const _precipitationMonthlyCacheKey = 'precipitationMonthly';
const _precipitationYearlyUri = '/data/Precip/v1/YearlyByLatLon';
const _precipitationYearlyCacheKey = 'precipitationYearly';

export class PrecipitationProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_precipitationMonthlyCacheKey] = this.PrecipitationMonthlySyncer.bind(this);
        this.storage.sync[_precipitationYearlyCacheKey] = this.PrecipitationYearlySyncer.bind(this);
    }

    async PrecipitationMonthlySyncer(params) {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , latitude: syncParams.latitude
            , longitude: syncParams.longitude
            , verbose: syncParams.verbose
            , units: 'English'
        };

        const { lengthUnit } = syncParams;
        const unitConversionFunc = (result) => {
            if (result) {
                result.v = getLength(result.v, lengthUnit, false, 2);
            }

            return result;
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _precipitationMonthlyUri
            , resolve
            , reject
            , /*responseValidator*/ null
            , syncParams.pulseApi
            , null
            , unitConversionFunc
        );
    }

    async PrecipitationYearlySyncer(params) {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , latitude: syncParams.latitude
            , longitude: syncParams.longitude
            , verbose: syncParams.verbose
            , units: 'English'
        };

        const { lengthUnit } = syncParams;
        const unitConversionFunc = (result) => {
            if (result) {
                result.v = getLength(result.v, lengthUnit, false, 2);
            }

            return result;
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _precipitationYearlyUri
            , resolve
            , reject
            , /*responseValidator*/ null
            , syncParams.pulseApi
            , null
            , unitConversionFunc
        );
    }

    async getPrecipitationMonthly(latitude, longitude, stdParameters, verbose, refresh=false, lengthUnit) {
        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            lengthUnit
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;
        if (refresh) {
            super.removeFromStorage(_precipitationMonthlyCacheKey, id);
        }

        return await super.loadFromStorage(_precipitationMonthlyCacheKey, id, syncParams);
    }
    async getPrecipitationYearly(latitude, longitude, stdParameters, verbose, refresh = false, lengthUnit) {

        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            lengthUnit
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;
        if (refresh) {
            super.removeFromStorage(_precipitationYearlyCacheKey, id);
        }

        return await super.loadFromStorage(_precipitationYearlyCacheKey, id, syncParams);
    }
}

